import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "";
const addTakeAwayNewTable = (table) => axios.post(baseURL + 'tables/', table);
const addNewWaiter = (waiter) => axios.post(baseURL + 'waiters/', waiter);
const fetchTablesOfBranch = (params) => axios.post(baseURL + 'restaurants/get_tables_of_branch', params);
const fetchWaitersOfBranch = (params) => axios.post(baseURL + 'restaurants/get_waiters_of_branch', params);

export {
    addTakeAwayNewTable,
    fetchTablesOfBranch,
    addNewWaiter,
    fetchWaitersOfBranch
}